import { render, staticRenderFns } from "./HomeIntroSlides.vue?vue&type=template&id=3126a761&scoped=true"
import script from "./HomeIntroSlides.vue?vue&type=script&lang=ts"
export * from "./HomeIntroSlides.vue?vue&type=script&lang=ts"
import style0 from "./HomeIntroSlides.vue?vue&type=style&index=0&id=3126a761&lang=scss&scoped=true"
import style1 from "./HomeIntroSlides.vue?vue&type=style&index=1&id=3126a761&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126a761",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3126a761')) {
      api.createRecord('3126a761', component.options)
    } else {
      api.reload('3126a761', component.options)
    }
    module.hot.accept("./HomeIntroSlides.vue?vue&type=template&id=3126a761&scoped=true", function () {
      api.rerender('3126a761', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/HomeIntroSlides.vue"
export default component.exports